import api from "@/api/tasks";
import store from "@/store/store";

const fetchTasks = (context, criteria) => {
  return new Promise((resolve, reject) => {
    api
      .fetchTasks(
        criteria.pageIndex,
        criteria.searchTerm,
        criteria.filter,
        criteria.needAll,
        criteria.siteId
      )
      .then(response => {
        resolve(response);
        store.commit("tasks/storeTaskList", response);
      })
      .catch(error => {
        // eslint-disable-next-line
        reject(error);
      });
  });
};

const fetchCalendarTasks = (context, criteria) => {
  return new Promise((resolve, reject) => {
    api
      .fetchCalendarTasks(criteria.keyword, criteria.siteId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        // eslint-disable-next-line
        reject(error);
      });
  });
};

const fetchTask = (context, id) => {
  return new Promise((resolve, reject) => {
    api
      .fetchTask(id)
      .then(response => {
        resolve(response);
        store.commit("tasks/storeTask", response);
      })
      .catch(error => {
        // eslint-disable-next-line
        reject(error);
      });
  });
};

const updateTask = (context, params) => {
  return new Promise((resolve, reject) => {
    api
      .updateTask(params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });
};

const updateTaskStatus = (context, params) => {
  return new Promise((resolve, reject) => {
    api
      .updateTaskStatus(params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });
};

const createTask = (context, params) => {
  return new Promise((resolve, reject) => {
    api
      .createTask(params.params, params.siteId)
      .then(response => {
        resolve(response);
        store.commit("tasks/storeCreatedTask", response);
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });
};

const deleteTask = (context, id) => {
  return new Promise((resolve, reject) => {
    api
      .deleteTask(id)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });
};

const sendMessage = (context, params) => {
  return new Promise((resolve, reject) => {
    api
      .sendMessage(params)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  });
};

export default {
  fetchTasks,
  fetchTask,
  updateTask,
  updateTaskStatus,
  createTask,
  deleteTask,
  sendMessage,
  fetchCalendarTasks
};



// WEBPACK FOOTER //
// ./src/store/modules/tasks/actions.js